import { apiGet } from "./apiClient";
import { AdminLogLevelFilter, AdminLogPageDto } from "../Types/AdminLogTypes";

export interface AdminLogQueryParams {
  page?: number;
  pageSize?: number;
  level?: AdminLogLevelFilter;
  search?: string;
  from?: string;
  to?: string;
}

export const getAdminLogs = (params: AdminLogQueryParams): Promise<AdminLogPageDto> => {
  const searchParams = new URLSearchParams();

  if (params.page) searchParams.set("page", String(params.page));
  if (params.pageSize) searchParams.set("pageSize", String(params.pageSize));
  if (params.level && params.level !== "all") searchParams.set("level", params.level);
  if (params.search?.trim()) searchParams.set("search", params.search.trim());
  if (params.from) searchParams.set("from", params.from);
  if (params.to) searchParams.set("to", params.to);

  const query = searchParams.toString();
  return apiGet<AdminLogPageDto>(`/AdminLogs${query ? `?${query}` : ""}`);
};
